import { ASSET, COLLECTION, COMPANY, CONTACT, CUSTOM_FIELD, EXPIRY_DATE, FILE_TYPE, GROUP, STREAM, TAGS, TITLE, USER, USER_GROUP, DEAL_ROOM } from "src/types/clusterFilters";

export const CONTENT_MAP_FILTERS = [
  { 
      name: "Asset",
      value: ASSET,
      filter_type: 'entity_filter'
  },
  {
      name: "Asset Title",
      value: TITLE,
      filter_type: 'entity_filter'
  },
  {
      name: "Stream",
      value: STREAM,
      filter_type: 'entity_filter'
  },
  {
      name: "File Type",
      value: FILE_TYPE,
      filter_type: 'entity_filter',
  },
  {
      name: "Tags",
      value: TAGS,
      filter_type: 'entity_filter'
  },
  {
      name: "Group",
      value: GROUP,
      filter_type: 'entity_filter'
  },
  {
      name: "Asset Status",
      value: EXPIRY_DATE,
      filter_type: 'entity_filter'
  }
];

export const SUBFILTERS = [
    {
        name: "is",
        value: "is",
        type: [TAGS, ASSET, STREAM, FILE_TYPE, GROUP, CUSTOM_FIELD, COLLECTION, USER , USER_GROUP, CONTACT, COMPANY, DEAL_ROOM]
    },
    {
        name: "is not",
        value: "is_not",
        type: [TAGS, ASSET, STREAM, FILE_TYPE, GROUP, CUSTOM_FIELD, COLLECTION, USER , USER_GROUP, CONTACT, COMPANY, DEAL_ROOM]

    },
    {
        name: "contains",
        value: "contains",
        type: [TITLE]
    },
    {
        name: "is empty",
        value: "is_empty",
        type: [TAGS, CUSTOM_FIELD]
        
    },
    {
        name: "is not empty",
        value: "is_not_empty",
        type: [TAGS, CUSTOM_FIELD]
        
    },
    {
        name: "expired",
        value: "expired",
        type: [EXPIRY_DATE]
    },
    {
        name: "no expiration",
        value: "not_expired",
        type: [EXPIRY_DATE]
    },
    {
        name: "expiring",
        value: "expiring",
        type: [EXPIRY_DATE]
    },
    {
        name: "has role",
        value: "has_role",
        type: [USER]
    },
    {
        name: "is internal",
        value: "is_internal",
        type: [CONTACT, COMPANY]
    },
    {
        name: "is not internal",
        value: "is_not_internal",
        type: [CONTACT, COMPANY]
    }
]

export const FILE_TYPES = [
    { key: 'PDF', value: 'PDF', text: 'PDF' },
    { key: 'VIDEO', value: 'VIDEO', text: 'VIDEO' },
    { key: 'IMAGE', value: 'IMAGE', text: 'IMAGE' },
    { key: 'PPTX', value: 'PPTX', text: 'PPTX' },
    { key: 'PPT', value: 'PPT', text: 'PPT' },
    { key: 'DOC', value: 'DOC', text: 'DOC' },
    { key: 'DOCX', value: 'DOCX', text: 'DOCX' },
    { key: 'YOUTUBE', value: 'YOUTUBE', text: 'YOUTUBE' },
    { key: 'VIMEO', value: 'VIMEO', text: 'VIMEO' },
    { key: 'WISTIA', value: 'WISTIA', text: 'WISTIA' },
    { key: 'VIDYARD', value: 'VIDYARD', text: 'VIDYARD' },
    { key: 'LINK', value: 'LINK', text: 'LINK ' },
    { key: 'AUDIO', value: 'AUDIO', text: 'AUDIO' },
    { key: 'INTERACTIVE', value: 'INTERACTIVE', text: 'INTERACTIVE' }
]

export const CONTENT_EXPIRY_FILTERS = [
    {
        name: 'In a month', 
        value: 'one_month'
    },
    {
        name: 'In a week', 
        value: 'one_week'
    },
    {
        name: 'In a day', 
        value: 'one_day'
    }
]

export const UPDATE_CONTENT_EXPIRY_FILTERS = [{ 
    name: `1 month`,
    value: 'one_month'
  },
  { 
    name: `3 months`, 
    value: 'three_month'
  },
  { 
    name: `6 months`, 
    value: 'six_month'
  },
  { 
    name: `12 months`, 
    value: 'twelve_month'
  }]

  export const MASTER_ASSET_SCHEMA = [
    {
        column: 'ID',
        type: String,
        value: asset => asset.id
    },
    {
        column: 'Name',
        type: String,
        value: asset => asset.name
    },
    {
        column: 'Content Type',
        type: String,
        value: asset => asset.extension
    },
    {
        column: 'File Size',
        type: String,
        value: asset => asset.filesize
    },

    {
        column: 'Source',
        type: String,
        value: asset => asset.source
    },
    {
        column: 'Additional Metadata',
        type: String,
        value: asset => asset.assetmetadata,
    },
    {
        column: 'Url',
        type: String,
        value: asset => asset.url,
    },
    
    {
        column: 'Internal Description',
        type: String,
        value: asset => asset.summary
    },
    {
        column: 'External Description',
        type: String,
        value: asset => asset.externalSummary
    },
    {
        column: 'Tags',
        type: String,
        value: asset => asset.tags
    },
    {
        column: 'Author',
        type: String,
        value: asset => asset.author
    },
    {
        column: 'Custom Fields',
        type: String,
        value: asset => asset.customFields
    },
    {
        column: 'Created Date',
        type: String,
        value: asset => asset.createdDate
    },
    {
        column: 'Updated Date',
        type: String,
        value: asset => asset.updatedDate
    }, 
    {
        column: 'Expiry Date',
        type: String,
        value: asset => asset.expiryDate
    },
    {
        column: 'Stream Names',
        type: String,
        value: asset => asset.streamNames
    },
    {
        column: 'Group Names',
        type: String,
        value: asset => asset.groupNames
    },
    {
        column: 'Internal Download',
        type: Number,
        value: asset => asset.internalDownloads
    },
    {
        column: 'External Download',
        type: Number,
        value: asset => asset.externalDownloads
    },
    {
        column: 'Avg Internal Timespent (sec)',
        type: Number,
        value: asset => asset.avgInternalTimeSpent
    },
    {
        column: 'Avg External Timespent (sec)',
        type: Number,
        value: asset => asset.avgExternalTimeSpent
    },
    {
        column: 'Average Timespent (sec)',
        type: Number,
        value: asset => asset.avgTimeSpent
    },
    {
        column: "Internal Views",
        type: Number,
        value: asset => asset.internalViews
    },
    {
        column: "External Views",
        type: Number,
        value: asset => asset.externalViews
    },
    {
        column: "Shares",
        type: Number,
        value: asset => asset.shares
    }
]